import { Button, Upload as UploadAntd } from "antd";
import React, { useState, useEffect } from "react";
import { UploadOutlined } from "@ant-design/icons";
import { ShowToast, Severty } from "../helper/toast";
import useRequest from "../hooks/useRequest";
import lang from "../helper/langHelper";
const SingleImageUpload = ({
  fileType,
  value,
  imageType,
  btnName,
  onChange,
  size = 5,
  width = 600,
  height = 600,
  isDimension = false,
  ...props
}) => {
  const { request } = useRequest();
  const [file, setFile] = useState([]);
  const [loading, setLoading] = useState(false);

  const checkImageDimensions = (file) => {
    return new Promise((resolve, reject) => {
      const img = document.createElement("img");

      img.onload = () => {
        if (img.width === width && img.height === height) {
          resolve();
        } else {
          reject(
            `Please upload an image with dimensions (${width}X${height}). uploaded image is ${img.width} X ${img.height}`
          );
        }
      };

      img.src = URL.createObjectURL(file);
    });
  };

  const beforeUpload = async (file) => {
    try {
      if (fileType.includes(file.type)) {
      } else {
        ShowToast("File format is not correct", Severty.ERROR);
        return false;
      }
      const isLt2M = file.size / 1024 / 1024 < size;

      if (!isLt2M) {
        ShowToast(`Image must be smaller than ${size} MB!`, Severty.ERROR);
        return false;
      }
      // If check dimension
      // isDimension && (await checkImageDimensions(file));
      return true;
    } catch (err) {
      ShowToast(err, Severty.ERROR);
      return false;
    }
  };

  const onRemove = () => {
    setFile([]);
    if (onChange) {
      onChange("");
    }
  };

  useEffect(() => {
    if (value) {
      setFile([value]);
    } else {
      setFile([]);
    }
  }, [value]);

  const uploadFileToBackend = async (file) => {
    return new Promise((resolve, reject) => {
      const formData = new FormData();
      formData.append("file", file);
      if (imageType) {
        formData.append("folder", `aleef/${imageType}`);
      }
      
      request({
        url: "backend/upload",
        method: "POST",
        data: formData,
        onSuccess: (data) => {
          resolve(data);
        },
        onError: (error) => {
          reject(error);
        }
      });
    });
  };

  const handleImgChange = async (event) => {
    const { file } = event;
    setFile([file]);
    setLoading(true);
    try {
      const data = await uploadFileToBackend(file);
      const fileData = {
        uid: file.uid,
        name: file.name,
        status: "done",
        url: data.url,
        thumbUrl: data.url,
      };
      setFile([fileData]);
      if (onChange) {
        onChange([fileData]);
      }
    } catch (err) {
      console.error(err);
      const fileData = {
        uid: file.uid,
        name: file.name,
        status: "error",
      };
      setFile([fileData]);
    } finally {
      setLoading(false);
    }
  };

  return (
    <UploadAntd
      color="white"
      listType="picture"
      maxCount={1}
      beforeUpload={beforeUpload}
      customRequest={handleImgChange}
      onRemove={onRemove}
      fileList={file}
      {...props}
    >
      {file && file.length > 0 && file !== "" ? null : (
        <Button icon={<UploadOutlined />} loading={loading}>
          {" "}
          {loading ? "Uploading..." : btnName ? `${lang("Upload")} ${btnName}` : ""}
        </Button>
      )}
    </UploadAntd>
  );
};

export default SingleImageUpload;
